export const environment = {
      production: true,
      apiUrl: '#{ApiUrl}#',
      apiUrlLogin: '#{ApiUrlLogin}#',
      appVersion: require('../../package.json').version
};
